import axios from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { refreshGen } from '../auth/saga/refresh';
import history from '../../utils/history';
import routes from '../../constants/routes';
import actionTypes from '../auth/actionTypes';
import { SUBSCRIPTION_DENIED, getSubscriptionMessage } from './subscriptionMessage';

const baseURL = process.env.REACT_APP_REST_API_URL;

export const client = axios.create({
  baseURL,
});

export default function* apiSaga(requestConfig) {
  try {
    const token = localStorage.getItem('accessToken');
    client.defaults.headers.Authorization = `Bearer ${token}`;
    return yield call(client, requestConfig);
  } catch (err) {
    if (err.response) {
      if (err.response.data.message === 'token contains an invalid number of segments'
        && requestConfig.url === '/game') {
        throw new Error('Please log in for getting access to training');
      }
      if (err.response.data.message === 'Token is expired') {
        if (requestConfig.url === '/refresh') return null;
        const token = yield call(refreshGen);
        if (!token) throw new Error('Session expired. Please log in again.');
        yield client.defaults.headers.Authorization = `Bearer ${token?.access_token}`;
        return yield call(client, requestConfig);
      }
      if (err.response.data.message === 'token expired') {
        yield put({ type: actionTypes.LOGOUT });
        history.push(routes.app.trainingGame.root);
        throw new Error('Your are not authenticated');
      }
      if (err.response.data.message === 'banned by admin') {
        history.push(routes.app.trainingGame.root);
        yield put({ type: actionTypes.LOGOUT });
        throw new Error('Your have been banned');
      }
      if (err.response.data.message === 'not authenticated') {
        yield put({ type: actionTypes.LOGOUT });
        history.push(routes.app.trainingGame.root);
        throw new Error('Not authenticated');
      }
      if (err.response.data.message === 'email already exist') {
        throw new Error('Email already exists');
      }
      if (err.response.data.message === 'email: must be a valid email address.') {
        throw new Error('Incorrect email');
      }
      if (err.response.data.message === SUBSCRIPTION_DENIED) {
        let user = yield select((state) => state.profile.user);
        if (!user || !user.rate || !user.payment_date) {
          try {
            const profile = yield call(client, { method: 'get', url: '/whoami', timeout: 4000 });
            user = profile.data.user;
          } catch (profileError) {
            // Keep the original message if the subscription cannot be confirmed.
          }
        }
        const error = new Error(getSubscriptionMessage(
          user, requestConfig.url, localStorage.getItem('i18nextLng') || 'en',
        ));
        // Preserve the API error identifier used by the existing redirect handlers.
        error.originalMessage = SUBSCRIPTION_DENIED;
        throw error;
      }
      throw new Error(err.response.data.message);
    }
    throw new Error(err);
  }
}
